export default __webpack_public_path__ + "static/media/main_saying01_en.719d186b.png";